import React, { useState } from "react";
import { TeamItems } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import GoToTop from "./GoToTop";

function DropdownT() {
  const [dropdownT, setDropdownT] = useState(false);

  return (
    <>
      <ul
        className={dropdownT ? "submenu clicked" : "submenu"}
        onClick={() => setDropdownT(!dropdownT)}
      >
        {TeamItems.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => {setDropdownT(false);GoToTop();}}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownT;
